import { ORDER_ACTION_TYPES } from '../actions/orderAction';

// 初始状态
const initialState = {
  // 公开SKU列表（不需要登录）
  publicSkus: {
    data: [],
    count: 0,
    loading: false,
    error: null,
    lastFetched: null
  },
  
  // 用户可用套餐列表
  userAvailableSkus: {
    data: [],
    count: 0,
    loading: false,
    error: null,
    lastFetched: null
  },
  
  // 原子商品列表
  atomicProducts: {
    data: [],
    count: 0,
    loading: false,
    error: null,
    lastFetched: null
  },
  
  // 积分交易记录
  pointsTransactions: {
    data: [],
    pagination: {
      current_page: 1,
      total_pages: 1,
      total_records: 0,
      page_size: 10,
      has_next: false,
      has_prev: false
    },
    loading: false,
    error: null,
    lastFetched: null
  },
  
  // 支付订单状态
  paymentOrder: {
    // 当前订单信息
    currentOrder: null,
    // 支付状态
    paymentStatus: null,
    // 创建订单状态
    creating: false,
    createError: null,
    // 查询状态
    checking: false,
    checkError: null,
    // 取消订单状态
    cancelling: false,
    cancelError: null,
    // 最后更新时间
    lastUpdated: null
  }
};

// Reducer
const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    // 获取公开SKU列表 - 请求开始
    case ORDER_ACTION_TYPES.FETCH_PUBLIC_SKUS_REQUEST:
      return {
        ...state,
        publicSkus: {
          ...state.publicSkus,
          loading: true,
          error: null
        }
      };
    
    // 获取公开SKU列表 - 请求成功
    case ORDER_ACTION_TYPES.FETCH_PUBLIC_SKUS_SUCCESS:
      return {
        ...state,
        publicSkus: {
          ...state.publicSkus,
          data: action.payload.skus,
          count: action.payload.count,
          loading: false,
          error: null,
          lastFetched: new Date().toISOString()
        }
      };
    
    // 获取公开SKU列表 - 请求失败
    case ORDER_ACTION_TYPES.FETCH_PUBLIC_SKUS_FAILURE:
      return {
        ...state,
        publicSkus: {
          ...state.publicSkus,
          loading: false,
          error: action.payload.error,
          data: [],
          count: 0
        }
      };
    
    // 获取用户可用套餐列表 - 请求开始
    case ORDER_ACTION_TYPES.FETCH_USER_AVAILABLE_SKUS_REQUEST:
      return {
        ...state,
        userAvailableSkus: {
          ...state.userAvailableSkus,
          loading: true,
          error: null
        }
      };
    
    // 获取用户可用套餐列表 - 请求成功
    case ORDER_ACTION_TYPES.FETCH_USER_AVAILABLE_SKUS_SUCCESS:
      return {
        ...state,
        userAvailableSkus: {
          ...state.userAvailableSkus,
          data: action.payload.skus,
          count: action.payload.count,
          loading: false,
          error: null,
          lastFetched: new Date().toISOString()
        }
      };
    
    // 获取用户可用套餐列表 - 请求失败
    case ORDER_ACTION_TYPES.FETCH_USER_AVAILABLE_SKUS_FAILURE:
      return {
        ...state,
        userAvailableSkus: {
          ...state.userAvailableSkus,
          loading: false,
          error: action.payload.error,
          data: [],
          count: 0
        }
      };
    
    // 清空用户可用套餐列表
    case ORDER_ACTION_TYPES.CLEAR_USER_AVAILABLE_SKUS:
      return {
        ...state,
        userAvailableSkus: {
          data: [],
          count: 0,
          loading: false,
          error: null,
          lastFetched: null
        }
      };
    
    // 获取原子商品列表 - 请求开始
    case ORDER_ACTION_TYPES.FETCH_ATOMIC_PRODUCTS_REQUEST:
      return {
        ...state,
        atomicProducts: {
          ...state.atomicProducts,
          loading: true,
          error: null
        }
      };
    
    // 获取原子商品列表 - 请求成功
    case ORDER_ACTION_TYPES.FETCH_ATOMIC_PRODUCTS_SUCCESS:
      return {
        ...state,
        atomicProducts: {
          ...state.atomicProducts,
          data: action.payload.products,
          count: action.payload.count,
          loading: false,
          error: null,
          lastFetched: new Date().toISOString()
        }
      };
    
    // 获取原子商品列表 - 请求失败
    case ORDER_ACTION_TYPES.FETCH_ATOMIC_PRODUCTS_FAILURE:
      return {
        ...state,
        atomicProducts: {
          ...state.atomicProducts,
          loading: false,
          error: action.payload,
          data: [],
          count: 0
        }
      };
    
    // 清空原子商品列表
    case ORDER_ACTION_TYPES.CLEAR_ATOMIC_PRODUCTS:
      return {
        ...state,
        atomicProducts: {
          data: [],
          count: 0,
          loading: false,
          error: null,
          lastFetched: null
        }
      };
    
    // 获取积分交易记录 - 请求开始
    case ORDER_ACTION_TYPES.GET_POINTS_TRANSACTIONS_REQUEST:
      return {
        ...state,
        pointsTransactions: {
          ...state.pointsTransactions,
          loading: true,
          error: null
        }
      };
    
    // 获取积分交易记录 - 请求成功
    case ORDER_ACTION_TYPES.GET_POINTS_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        pointsTransactions: {
          ...state.pointsTransactions,
          data: action.payload.transactions,
          pagination: action.payload.pagination,
          loading: false,
          error: null,
          lastFetched: new Date().toISOString()
        }
      };
    
    // 获取积分交易记录 - 请求失败
    case ORDER_ACTION_TYPES.GET_POINTS_TRANSACTIONS_FAILURE:
      return {
        ...state,
        pointsTransactions: {
          ...state.pointsTransactions,
          loading: false,
          error: action.payload,
          data: [],
          pagination: {
            current_page: 1,
            total_pages: 1,
            total_records: 0,
            page_size: 10,
            has_next: false,
            has_prev: false
          }
        }
      };
    
    // 清空积分交易记录
    case ORDER_ACTION_TYPES.CLEAR_POINTS_TRANSACTIONS:
      return {
        ...state,
        pointsTransactions: {
          data: [],
          pagination: {
            current_page: 1,
            total_pages: 1,
            total_records: 0,
            page_size: 10,
            has_next: false,
            has_prev: false
          },
          loading: false,
          error: null,
          lastFetched: null
        }
      };
    
    // 创建支付订单 - 请求开始
    case ORDER_ACTION_TYPES.CREATE_PAYMENT_ORDER_REQUEST:
      return {
        ...state,
        paymentOrder: {
          ...state.paymentOrder,
          creating: true,
          createError: null
        }
      };
    
    // 创建支付订单 - 请求成功
    case ORDER_ACTION_TYPES.CREATE_PAYMENT_ORDER_SUCCESS:
      return {
        ...state,
        paymentOrder: {
          ...state.paymentOrder,
          currentOrder: action.payload,
          creating: false,
          createError: null,
          lastUpdated: new Date().toISOString()
        }
      };
    
    // 创建支付订单 - 请求失败
    case ORDER_ACTION_TYPES.CREATE_PAYMENT_ORDER_FAILURE:
      return {
        ...state,
        paymentOrder: {
          ...state.paymentOrder,
          creating: false,
          createError: action.payload,
          currentOrder: null
        }
      };
    
    // 查询支付状态 - 请求开始
    case ORDER_ACTION_TYPES.GET_PAYMENT_STATUS_REQUEST:
      return {
        ...state,
        paymentOrder: {
          ...state.paymentOrder,
          checking: true,
          checkError: null
        }
      };
    
    // 查询支付状态 - 请求成功
    case ORDER_ACTION_TYPES.GET_PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        paymentOrder: {
          ...state.paymentOrder,
          paymentStatus: action.payload,
          checking: false,
          checkError: null,
          lastUpdated: new Date().toISOString()
        }
      };
    
    // 查询支付状态 - 请求失败
    case ORDER_ACTION_TYPES.GET_PAYMENT_STATUS_FAILURE:
      return {
        ...state,
        paymentOrder: {
          ...state.paymentOrder,
          checking: false,
          checkError: action.payload
        }
      };
    
    // 取消支付订单 - 请求开始
    case ORDER_ACTION_TYPES.CANCEL_PAYMENT_ORDER_REQUEST:
      return {
        ...state,
        paymentOrder: {
          ...state.paymentOrder,
          cancelling: true,
          cancelError: null
        }
      };
    
    // 取消支付订单 - 请求成功
    case ORDER_ACTION_TYPES.CANCEL_PAYMENT_ORDER_SUCCESS:
      return {
        ...state,
        paymentOrder: {
          ...state.paymentOrder,
          cancelling: false,
          cancelError: null,
          paymentStatus: {
            ...state.paymentOrder.paymentStatus,
            order_status: 'cancelled',
            payment_status: 'failed'
          },
          lastUpdated: new Date().toISOString()
        }
      };
    
    // 取消支付订单 - 请求失败
    case ORDER_ACTION_TYPES.CANCEL_PAYMENT_ORDER_FAILURE:
      return {
        ...state,
        paymentOrder: {
          ...state.paymentOrder,
          cancelling: false,
          cancelError: action.payload
        }
      };
    
    // 清空支付订单状态
    case ORDER_ACTION_TYPES.CLEAR_PAYMENT_ORDER:
      return {
        ...state,
        paymentOrder: {
          currentOrder: null,
          paymentStatus: null,
          creating: false,
          createError: null,
          checking: false,
          checkError: null,
          cancelling: false,
          cancelError: null,
          lastUpdated: null
        }
      };
    
    default:
      return state;
  }
};

export default orderReducer;
